/// <reference types="vite/client" />

import { SuburbiaCore } from "./components/SuburbiaCore";

import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

new SuburbiaCore();
